import { useState } from 'react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/7c98916eb812ca4cf93aa2c27797fd8c/44ec1b641c4052dea549be961435c521.jpeg" 
              alt="Golden Black Logo" 
              className="w-8 h-8 mr-3"
            />
            <h1 className="text-2xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
              Golden Black
            </h1>
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <a href="/" className="text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
                Home
              </a>
              <a href="/about" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer">
                About
              </a>
              <a href="/services" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer">
                Services
              </a>
              <a href="/solutions" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer">
                Solutions
              </a>
              <a href="/contact" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer">
                Contact
              </a>
            </div>
          </div>

          <div className="hidden md:block">
            <button className="bg-teal-600 text-white px-6 py-2 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer">
              Get Quote
            </button>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-gray-900 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              <a href="/" className="text-gray-900 hover:text-teal-600 block px-3 py-2 text-base font-medium cursor-pointer">
                Home
              </a>
              <a href="/about" className="text-gray-700 hover:text-teal-600 block px-3 py-2 text-base font-medium cursor-pointer">
                About
              </a>
              <a href="/services" className="text-gray-700 hover:text-teal-600 block px-3 py-2 text-base font-medium cursor-pointer">
                Services
              </a>
              <a href="/solutions" className="text-gray-700 hover:text-teal-600 block px-3 py-2 text-base font-medium cursor-pointer">
                Solutions
              </a>
              <a href="/contact" className="text-gray-700 hover:text-teal-600 block px-3 py-2 text-base font-medium cursor-pointer">
                Contact
              </a>
              <button className="w-full text-left bg-teal-600 text-white px-3 py-2 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer mt-2">
                Get Quote
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
